import { gql, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import CarList from "./CarList";
import Typography from "@material-ui/core/Typography/Typography";
import {makeStyles} from "@material-ui/core/styles/index";

const GET_LIST = gql`
  query($text:String, $page:Int, $limit:Int, $make: Int, $model: Int, $city: String, $state: String, $year: Int,
   $modelMatch: String, $more: Boolean, $exclude: String, $sn: String, $filterOptions: [FilterOption]) {
        getList(searchInput: {text: $text, page: $page, limit: $limit, make: $make, model: $model, city: $city, state: $state,
         year: $year, modelMatch: $modelMatch, more: $more, exclude: $exclude, sn: $sn, filterOptions: $filterOptions}) {
        items {
          sn
          image
          title
          year
          price
          off
          sold
          requestCode
          city
          state
          hint
          mileage
        }
      }
  }
`;

const useStyles = makeStyles({
    root: {
        '@media print' : {
            display: 'none !important'
        }
    },
    popularCars: {
        margin: '15px 0 10px 10px',
        maxHeight: 40,
    },
});

export default function MoreCars(props) {

    const classes = useStyles();
    const [page, setPage] = useState(0);
    const { loading, error, data } = useQuery(GET_LIST, {variables: {
        text: '',
        more: true,
        make: props.make ? props.make : null,
        sn: props.sn ? props.sn : null,
        exclude: props.exclude ? props.exclude.join(',') : null,
        filterOptions: [{name: 'p', value: '1'}, {name: 'l', value: props.limit.toString()}]
    }});

    return (
        <div className={classes.root}>
            {props.title ?
                <Typography className={classes.popularCars}>{props.title}</Typography> : null}
            <CarList items={data ? data.getList.items : null} loading={loading} error={error}
                     search={props.search} handleClick={props.handleClick} quietMode={true} returnRoute={props.returnRoute}
                     listKey={props.listKey} yearCount={props.yearCount}
                     otherCarsTitle={props.otherCarsTitle}
                     scrollingAutoload={props.scrollingAutoload}
                     size={props.size}
                     isMobile={props.isMobile}/>
        </div>
    );
}


